import { Injectable } from '@angular/core';
import { BaseApiDataService } from 'app/core/storage/base-api-data.service';
import { OdqDateTime } from 'app/shared/model/odq-datetime.model';
import { Observable } from 'rxjs';
import { environment } from '~env';
import { MemberCorrespondenceType } from './member-correspondence-type.model';

const API_URL = environment.registrarCommandApi;

@Injectable({
  providedIn: 'root',
})
export class MemberCorrespondenceTypeCommandService {
  constructor(private dataService: BaseApiDataService<any>) { }

  chooseMemberCorrespondenceType(memberId: string, effectiveOn: Date, isResidenceAssigned: boolean): Observable<any> {
    return this.dataService.post(`${API_URL}/member/${memberId}/correspondence-type/assign`,
      {
        effectiveOn: (new OdqDateTime(effectiveOn)).toRfc3339(),
        isResidenceAssigned,
      });
  }

  correctMemberCorrespondenceType(memberId: string, correspondenceTypeId: string,
    effectiveOn: Date, isResidenceAssigned: boolean): Observable<any> {
    return this.dataService.post(
      // tslint:disable-next-line:max-line-length
      `${API_URL}/member/${memberId}/correspondence-type/${correspondenceTypeId}/correct`,
      {
        effectiveOn: (new OdqDateTime(effectiveOn)).toRfc3339(),
        isResidenceAssigned,
      });
  }

  cancel(memberId: string, correspondenceTypeId: string, effectiveOn: Date): Observable<void> {
    return this.dataService.post(`${API_URL}/member/${memberId}/correspondence-type/${correspondenceTypeId}/cancel`, {
      effectiveOn: effectiveOn.toISOString(),
    });
  }

  correctEffectiveDate(memberId: string, correspondenceType: MemberCorrespondenceType, newEffectiveDate: OdqDateTime): Observable<any> {
    return this.dataService.post(`${API_URL}/member/${memberId}/correspondence-type/${correspondenceType.id}/correct-date`,
      { EffectiveOn: correspondenceType.effectiveOn.toISOString(), NewEffectiveOn: newEffectiveDate.toRfc3339() });
  }
}
